export const defaultPrompt =
  'Generate a workshop deck by selecting/adding relevant sections and utilizing provided input files'

export const maximumFileSizeWarning =
  'The file size exceeds the maximum upload capability of 2GB, please upload a smaller file to proceed'
export const minimumFileSizeWarning =
  'The file size is suspiciously small, please check that it is not empty'
